import { createReducer, on } from "@ngrx/store";
import { ImportState, initialImportState } from "./import.state";
import {
  AuthorizeSSE,
  AuthorizeSSEError,
  AuthorizeSSESuccess,
  CancelImport,
  CancelImportError,
  CancelImportSuccess,
  ClearImportSession,
  DownloadErrorList,
  DownloadErrorListError,
  DownloadErrorListSuccess,
  GetImportStatusError,
  GetImportStatusSuccess,
  HasImport,
  HasImportError,
  HasImportSuccess,
  ResetImportState,
  UploadCSV,
  UploadCSVError,
  UploadCSVSuccess,
} from "./import.actions";

export const ImportReducers = createReducer(
  initialImportState,
  on(UploadCSV, (state): ImportState => {
    return {
      ...state,
      uploadLoader: true,
      uploadResult: null,
      uploadError: null,
    };
  }),
  on(UploadCSVSuccess, (state, action): ImportState => {
    return {
      ...state,
      uploadLoader: false,
      uploadResult: action.result,
    };
  }),
  on(UploadCSVError, (state, action): ImportState => {
    return {
      ...state,
      uploadLoader: false,
      uploadError: action.error,
    };
  }),
  on(GetImportStatusSuccess, (state, action): ImportState => {
    return {
      ...state,
      statusLoader: false,
      statusResult: action.result,
    };
  }),
  on(GetImportStatusError, (state, action): ImportState => {
    return {
      ...state,
      statusLoader: false,
      statusError: action.error,
    };
  }),
  on(AuthorizeSSE, (state): ImportState => {
    return {
      ...state,
      authSSELoader: true,
      authSSEResult: false,
      authSSEError: null,
    };
  }),
  on(AuthorizeSSESuccess, (state, action): ImportState => {
    return {
      ...state,
      authSSELoader: false,
      authSSEResult: action.result,
    };
  }),
  on(AuthorizeSSEError, (state, action): ImportState => {
    return {
      ...state,
      authSSELoader: false,
      authSSEError: action.error,
    };
  }),
  on(ResetImportState, (): ImportState => {
    return initialImportState;
  }),
  on(DownloadErrorList, (state): ImportState => {
    return {
      ...state,
      errorListFile: null,
      errorListLoader: true,
      errorListError: null,
    };
  }),
  on(DownloadErrorListSuccess, (state, action): ImportState => {
    return {
      ...state,
      errorListFile: action.result,
      errorListLoader: false,
    };
  }),
  on(DownloadErrorListError, (state, action): ImportState => {
    return {
      ...state,
      errorListLoader: false,
      errorListError: action.error,
    };
  }),
  on(HasImport, (state): ImportState => {
    return {
      ...state,
      hasImportLoader: true,
      hasImportResult: 0,
      hasImportError: null,
    };
  }),
  on(HasImportSuccess, (state, action): ImportState => {
    return {
      ...state,
      hasImportLoader: false,
      hasImportResult: action.result,
    };
  }),
  on(HasImportError, (state, action): ImportState => {
    return {
      ...state,
      hasImportLoader: false,
      hasImportError: action.error,
    };
  }),
  on(ClearImportSession, (state): ImportState => {
    return {
      ...state,
      clearSessionLoader: true,
    };
  }),
  on(CancelImport, (state): ImportState => {
    return {
      ...state,
      cancelImportLoader: true,
      cancelImportResult: null,
    };
  }),
  on(CancelImportSuccess, (state): ImportState => {
    return {
      ...state,
      cancelImportLoader: false,
      cancelImportResult: true,
    };
  }),
  on(CancelImportError, (state): ImportState => {
    return {
      ...state,
      cancelImportLoader: false,
      cancelImportResult: false,
    };
  })
);
